module.exports = __webpack_public_path__ + "static/media/email.d7cbde4d.png";